export default "__VITE_ASSET__CFbcxN6z__"